var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label",class:[
    { 'label--icon': _vm.icon },
    { 'label--success': _vm.colored && _vm.success },
    { 'label--warning': _vm.colored && _vm.warning },
    { 'label--error': _vm.colored && _vm.error }
  ]},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.iconText))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm._f("formatNumber")(_vm.number))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }